<template>
  <baidu-map
    :center="center"
    :zoom="zoom"
    @ready="handler"
    class="bm-view"
    :scroll-wheel-zoom="true"
  >
    <bm-navigation anchor="BMAP_ANCHOR_TOP_LEFT"></bm-navigation>
    <bm-marker :position="center" :dragging="false">
      <bm-label
        :content="myaddress"
        :labelStyle="{ color: 'black', fontSize: '12px' }"
        :offset="{ width: 0, height: 30 }"
      />
    </bm-marker>
  </baidu-map>
</template>
<script>
export default {
  data() {
    return {
      center: { lng: this.long, lat: this.latx },
      zoom: 15,
      myaddress: this.location,
    };
  },
  props: ["long", "latx", "location"],
  watch: {
    long: function (newVal, oldVal) {
      this.center.lng = newVal;
    },
    latx: function (newVal, oldVal) {
      this.center.lat = newVal;
    },
    location: function (newVal, oldVal) {
      this.myaddress = newVal;
      console.log(this.myaddress);
    },
  },
  methods: {
    handler({ BMap, map }) {},
  },
};
</script>
<style>
.bm-view {
  width: 100%;
  height: 500px;
}
/* .anchorBL {
  display: none;
} */
</style>



// WEBPACK FOOTER //
// src/components/map/baidu-map.vue